<template>
    <div>
        <el-row class="search-add" :gutter="10">
            <el-col :span="4">
                <el-input placeholder="用户名" v-model="username"></el-input>
            </el-col>
            <el-col :span="4">
                <el-input placeholder="手机号" v-model="mobile"></el-input>
            </el-col>
            <el-col :span="4">
                <el-select v-model="status" placeholder="请选择">
                    <el-option value="" label="请选择"></el-option>
                    <el-option value="0" label="禁用"></el-option>
                    <el-option value="1" label="启用"></el-option>
                </el-select>
            </el-col>
            <el-col :span="10">
                <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-col>
            <el-col :span="2">
                <router-link to="/setting/admin/add">
                    <el-button type="success">新增</el-button>
                </router-link>
            </el-col>
        </el-row>

        <el-table :data="data" border stripe style="width: 100%">
            <el-table-column prop="username" label="用户名">
            </el-table-column>
            <el-table-column prop="userNo" label="用户编号">
            </el-table-column>
            <el-table-column prop="mobile" label="手机号">
            </el-table-column>
            <el-table-column label="角色">
                <template slot-scope="scope">
                    <span v-for="x in scope.row.roles" :key="x.id">{{x.name}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="lastLoginTime" label="上次登录时间">
            </el-table-column>
            <el-table-column fixed="right" label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="Edit(scope.$index)">编辑</el-button>
                    <el-button @click="Delete(scope.$index,scope.row)" type="text" size="small">删除</el-button>
                    <el-button v-if="scope.row.status == 1" @click="Audit(scope.$index,0)" type="text" size="small">禁用</el-button>
                    <el-button v-else @click="Audit(scope.$index,1)" type="text" size="small">启用</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="tableDel-Page">
            <Pagination :params="pagin" @pageBind="getList"></Pagination>
        </div>
    </div>
</template>

<script>
    import Pagination from '@/components/Pagination';
    export default {
        name: 'admin',
        data() {
            return {
                username: '',//搜索框
                mobile: '',
                status: '',
                data: [],
                pagin: {
                    pageNum: 1,
                    pageSize: 20,
                    total: 0,
                },
                checkArray:[]//check选中
            }
        },
        methods: {
            search() {//搜索
                this.pagin.pageNum = 1;
                this.getList();
            },
            getList() {
                //数据绑定
                let params = {
                    pageNum: this.pagin.pageNum,
                    pageSize: this.pagin.pageSize,
                }
                if(this.username.trim() != '') {
                    params.username = this.username;
                }
                if(this.mobile.trim() != '') {
                    params.mobile = this.mobile;
                }
                if(this.status.trim() != '') {
                    params.status = this.status;
                }
                this.$http.post('/manage/user/list', params).then(results => {
                    this.data = results['data']['data']['records'];
                    this.pagin.total = results['data']['data']['total'];
                });
            },
            Edit(index) {
                this.$store.commit('setEditInfo',this.data[index]);
                this.$router.push('./edit/'+this.data[index].id);
            },
            Delete(index) {
                //单删
                if(confirm('确认要删除吗？')) {
                    let ID = this.data[index].id;
                    this.$http.post('/manage/user/del',{id:ID}).then(() => {
                        this.data.splice(index, 1);
                    })
                }
            },
            Audit(index,status) {
                if(confirm('操作前确认')) {
                    this.$http.post('/manage/user/enable',{id:this.data[index].id,status:status}).then(() => {
                        this.data[index].status = status;
                    });
                }
            }
        },
        components: { Pagination }
    }
</script>